import _groupBy from 'lodash.groupby';
/* eslint-disable no-nested-ternary */
// @vue/component
export default {
  name: 'ConnectionType',

  props: {
    connectionTypesMap: {
      type: Array,
      default: () => [],
    },
    isDialout: {
      type: Boolean,
      default: false,
    },
    isMassDial4call: {
      type: Boolean,
      default: false,
    },
    isCallweb: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      connectionTypeName: 'ivr',
    };
  },
  computed: {
    getConnectionTypesByName() {
      return _groupBy(this.connectionTypesMap, 'type');
    },
    connectionTypeNameComputed() {
      if (this.getConnectionTypesByName[this.connectionTypeName][0].type_name === 'Ivr') {
        return this.getConnectionTypesByName[this.connectionTypeName][0].type_name.toUpperCase();
      }
      return this.getConnectionTypesByName[this.connectionTypeName][0].type_name;
    },
  },
  watch: {
    connectionTypesMap() {
      this.setConnectionTypeName();
    },
  },
  created() {
    this.setConnectionTypeName();
  },
  methods: {
    getLighterColor(colorValue) {
      const color = require('color');
      return color(colorValue).lighten(0.2);
    },
    getDarkenColor(colorValue) {
      const color = require('color');
      return color(colorValue).darken(0.4);
    },
    setConnectionTypeName() {
      this.connectionTypeName = this.isDialout
        ? 'dialout'
        : this.isMassDial4call
          ? 'massdial4call'
          : this.isCallweb
            ? 'callweb'
            : 'ivr';
    },
  },
};
